export const configOptions = (token: string) => {
  return { headers: { Authorization: `Bearer ${token}` } };
};
